import './index.css';

export default {
  name: 'Anavbar',
  props: {
    id: { type: String, default: () => (`a-navbar-${Math.random().toString().substring(2)}`) },
    size: { type: String, default: () => 'success' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    size: { type: String, default: () => 'small' },
    closable: { type: Boolean, default: () => true },
    disableTransitions: { type: Boolean, default: () => false },
    effect: { type: String, default: () => 'light' },
  },
  data() {
    return {
      active: '',
      list: [],
    }
  },
  created() {
    this.assign();
  },
  watch: {
    $route({ path, meta }) {
      this.active = path;
      this.$nextTick(() => {
        let item = { text: meta.text, path: path };
        if (!JSON.stringify(this.list).includes(JSON.stringify(item))) {
          this.list.unshift(item);
          this.$nextTick(() => {
            let data = { data: this.list, active: this.active };
            this.$emit('change', data);
          });
        }
      });
    },
  },
  methods: {
    assign() {
      this.list = this.options || this.option || this.config || this.items || this.data || [];
      this.$nextTick(() => this.active = location.pathname);
    },
    click({ path }) {
      if (location.pathname != path) {
        this.active = path;
        this.$nextTick(() => {
          this.$router.push(path);
          this.$nextTick(() => {
            this.$emit('click', path);
            this.$emit('select', path);
          });
        });
      }
    },
    close(index) {
      this.list.splice(index, 1);
      this.$nextTick(() => {
        this.$emit('close', index);
        this.$emit('cancel', index);
      });
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return this.list.length > 0 && (
      <div class="a-navbar">
        <AscrollBox>
          <div id={this.id} class="a-navbar-container">
            {this.list.map((a, b) => (
              <el-tag
                key={b}
                size={this.size}
                effect={this.effect}
                closable={(a.path == this.active) ? null : this.closable}
                type={a.type ? a.type : this.type}
                on-click={() => this.click(a)}
                on-close={() => this.close(b)}
                disable-transitions={this.disableTransitions}
                class={(a.path == this.active) ? 'active' : null}
                effect={(a.path == this.active) ? 'dark' : null}
                {...{ attrs }}
              >
                {a.rander ? () => a.rander(a) : a.text}
              </el-tag>
            ))}
          </div>
        </AscrollBox>
      </div>
    );
  }
}